// 중남미 스페인어

export default {
  LandingPage: {
    intro_sub:
      'Dale un segundo uso a nuestro empaque y contribuye a proteger nuestro medio ambiente',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Únete a nosotros para reducir residuos',
    sequence1_2:
      'usa el empaque de tu producto y conviértelo en nuevas cosas útiles y ayúdanos a crear un ambiente sustentable. Sigue leyendo para encontrar el primer paso',
    sequence2_1: 'Conoce nuestro nuevo Samsung Upcycle-Packaging',
    sequence2_2:
      'Corta el empaque siguiendo las instrucciones y ensambla para crear nuevas cosas increíbles',
    sequence3_1: 'Sigue los puntos impresos en el empaque',
    sequence3_2:
      'Corta el empaque siguiendo las instrucciones y ensambla para crear nuevas cosas increíbles',
    sequence4_1: 'Selecciona el objeto que quieras hacer',
    sequence4_2:
      'Sigue bajando hasta seleccionar el modelo de caja de tu producto. Encuentra varias opciones de posibles diseños. Ahora ya puedes empezar a crear el diseño que quieres',
    selectBox: 'Seleccione su producto',
    moreActivity:
      'Conoce más información sobre actividades sostenibles de Samsung',
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame',
    theSerif: 'The Serif',
    theSero: 'The Sero',
    theTerrace: 'The Terrace',
    thePremiere: 'The Premiere',
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet02:'Soundbar Set 2',
    SoundbarSet01:'Soundbar Set 1',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/latin/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/latin/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/latin/sustainability/overview/',
    footer: 'Copyright© 2019-2021 SAMSUNG. Todos los derechos reservados.',
    //  <br/>
    //   Este sitio web se ve mejor con Microsoft Internet Explorer 11 o superior y con las últimas versiones de Google Chrome y Mozilla Firefox.
  },
  ProductPage: {
    selectDesign: 'Seleccione el diseño para crear',
    selectDesignDezeen: 'Samsung X Dezeen',
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'Mesa de TV',
    StorageBox: 'Caja de almacenaje',
    MagazineRack: 'Revistero',
    CatHouse: 'Casa del gato',
    CatTunnel: 'Túnel de gato',
    BookShelf: 'Estante para libros',
    DeskShelf: 'Estante de escritorios',
    BlackRhino: 'Endangered \n Animals \n Black Rhino', //update
    PolarBear: 'Endangered \n Animals \n Polar Bear', //update
    SeaTurtle: 'Endangered \n Animals \n Sea Turtle', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex Couch \n Arm Table', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko table', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Postcard \n Planter', //update
    SneakerRack: 'Sneaker \n Rack', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Tool Box', //update
    DeskStationary: 'Papelería',
    CoinBank: 'Alcancía',
    MobileScanner:'Soporte de escáner smartphone',
    TabletScanner:'Soporte para escáner de tablet',
    PetStairs:'Escaleras para mascotas',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'Minutos',
    all:'ALL',
    in: 'Pulgadas',
    inOnly: 'Solo Pulgadas',
    allBoxSize: 'Todos los tamaños de la caja',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'Instrucciones',
    prepare: 'Prepare la caja',
    LetsDesign: 'Vamos a diseñar',
    drawParts: 'Dibuje las partes encima de la caja',
    note1:
      'Tenga en cuenta que la posición gráfica puede variar según el país y el tamaño.',
    note2: 'Primero dibuje primero todo el dibujo para que quepa en la caja',
    numberSpace: 'Número = Espacios entre los puntos',
    diagonal: 'Diagonal',
    LEFT: 'IZQUIERDA',
    RIGHT: 'DERECHA',
    TOP: 'ARRIBA',
    TOP1: 'ARRIBA 1',
    TOP2: 'ARRIBA 2',
    BACK: 'ATRÁS',
    MIDDLE: 'MEDIO',
    MIDDLE2: 'MEDIO 2',
    BOTTOM: 'ABAJO',
    FRONT: 'FRENTE',
    SIDE: 'DE LADO',
    secondSIDE: 'SEGUNDO LADO',
    secondSIDE1: 'SEGUNDO LADO 1',
    secondSIDE2: 'SEGUNDO LADO 2',
    LEG: 'PIERNA', //update
    JOINT: 'BISAGRA', //update
    FACE: 'CARA', //update
    DRAWERBOTTOM: 'PARTE INFERIOR DEL CAJÓN', //update
    DRAWERSIDE: 'PARTE LATERAL DEL CAJÓN', //update
    NOSE: 'PARTE FRONTAL', //update
    HANDLE: 'AGARRADERO', //update
    BOTTOMSIDE: 'LADO INFERIOR', //update
    TOPSIDE: 'LADO SUPERIOR', //update
    WING: 'ALA', //update
    cutAndAssemble: 'Vamos a cortar y armar',
    beCareful: 'Tenga cuidado de no lastimarse cuando use el cortador',
    cutOutParts: 'Corte las partes',
    assemble: 'Arme',
    Assemblyguide: 'Guía para armar', //update
    fold: 'Ejemplo plegable',
    foldGuide: 'Usa el borde de los muebles al doblar el cartón',
    foldGuideDezeen:
      'Presione varias veces la línea punteada en el cartón con herramientas para plegar, para que el cartón se doble.', //update
    glue:
      'Aplique pegamento o cinta adhesiva de manera uniforme sobre la superficie', //update
    cable: 'Utilice ataduras de cables para conectar', //update
    done: '¡Hecho!',
    goBack: 'Volver al menú principal',
  },
  CautionPage: {
    CAUTION: 'PRECAUCIÓN',
    needItem: 'Necesitará éstos artículos',
    children: 'Los niños deben estar acompañados de adultos',
    mat:
      'Coloque una cubierta en el suelo para evitar cualquir daño durante el  proceso.',
    doNotPutHeavyThing:
      'No pise ni siente en estos muebles y trate de no poner cosas pesadas',
    doNotThrow: 'No arroje ni patee muebles hacia personas ni animales.',
    stayAwayFlame: 'Mantenga alejado de fuego',
    stayAwayWater: 'Mantenga alejado de agua o humedad',
    mayDamaged:
      '* La caja de TV puede estar dañado durante el proceso de envío',
    companyDoestResponsible:
      '* La empresa no se hace responsable de daños o defectos durante el proceso',
    cannotBeReturned:'',
    understand: 'Si. Entendido.',
  },
  PrivacyPolicy: {
    title: 'Política de privacidad',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Estamos intensificando nuestro compromiso con la sostenibilidad con nuestro nuevo empaque ecológico.',
      text2:
        'Usamos menos papel y tinta para empaques de televisores que pueden convertirse en artículos para el hogar.',
      text2_special:'',
      text3: 'Seleccione los botones de abajo para descubrir más.',
    },
    greenIn: {
      title: 'La opción ecológica en los paquetes de TV',
      subtitle1: 'Información del producto sin tinta',
      subtitle2: 'Paquete ecológico de reciclaje',
      desc: 'Busque el nombre del modeo para obtener más información',
      descM: '*Take a photo of the TV model number',
      guide: 'Nombre del modelo',
      button: 'Take Photo',
      button2: 'Ir a hacer artículos',
    },
    search: {
      guide: 'Search..',
      noResult: 'No hay resultados',
      more: 'Ver más',
    },
  },
  searchCountrySelect: 'Seleccione un país para buscar'
};
